import styled from "styled-components";

import { translate } from "app/filters/i18nFilter";

import { Box, SerpCount, SearchSerpContainer, Grid, SerpWidgetTitleText } from "../../StyledComponents";
import { SerpTileContent } from "../serp-tile/SerpTile";

const NoDataGrid = styled(Grid)`
    opacity: 0.2;
`;
const NoDataSearchSerpContainer = styled(SearchSerpContainer)``;
const Text = styled(SerpCount)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 271px;
    height: 20px;
`;
const GridWrapper = styled.div`
    position: relative;
`;
const NoSerpDataSerpTileContainer = styled(Box)`
    cursor: default;
    &:hover {
        box-shadow: none;
    }
    @media (max-width: 1540px) {
        &:nth-last-child(1) {
            display: none;
        }
    }
`;

type SerpFeatureNoSerpData = "featured" | "paid" | "news" | "video" | "images";

const serpFeatureNoSerpData: SerpFeatureNoSerpData[] = ["featured", "paid", "news", "video", "images"];

const NoSerpDataSerpTile = ({ serpFeature }: { serpFeature: SerpFeatureNoSerpData }) => (
    <NoSerpDataSerpTileContainer>
        <SerpTileContent serpName={serpFeature}>
            <SerpCount>
                {translate("serp.top.table.widgets.serp.tile.subtitle.websites", {
                    serpFeaturesCount: 0,
                })}
            </SerpCount>
        </SerpTileContent>
    </NoSerpDataSerpTileContainer>
);

export const NoSerpData = () => (
    <NoDataSearchSerpContainer>
        <SerpWidgetTitleText>{translate("serp.top.table.widgets.title")}</SerpWidgetTitleText>
        <GridWrapper>
            <NoDataGrid>
                {serpFeatureNoSerpData.map((serpFeature) => (
                    <NoSerpDataSerpTile
                        key={serpFeature}
                        serpFeature={serpFeature}
                    />
                ))}
            </NoDataGrid>
            <Text>{translate("serp.top.table.widgets.no_serp_data")}</Text>
        </GridWrapper>
    </NoDataSearchSerpContainer>
);
